module.exports = __webpack_public_path__ + "img/intro_img.8ac5bc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro_img.png
// module id = A3X5
// module chunks = 1